import React, { forwardRef, type HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';
import { shortenHash } from '@soundxyz/utils/const';
import { Avatar } from '@components/basics/Images/Avatar';
import { VerifiedRainbow } from '@components/icons/VerifiedRainbow';

interface Props extends HTMLAttributes<HTMLLIElement> {
  webappUri: string;
  avatarUrl: string | null;
  publicAddress: string;
  showVerified: boolean;
  selected: boolean;
  displayName: string;
}
export const MentionCell = forwardRef<HTMLLIElement, Props>(
  ({ publicAddress, displayName, selected, showVerified, webappUri, avatarUrl, ...rest }, ref) => {
    return (
      <li
        className={twMerge(
          `-mx-2 -my-2 mb-3 flex cursor-pointer items-center gap-3 overflow-hidden rounded-md px-2 py-2 last:mb-0 only:mb-0`,
          selected ? 'bg-base200' : ' bg-white ',
        )}
        {...rest}
        ref={ref}
      >
        <div className="aspect-square h-8 w-8 flex-00auto">
          <Avatar
            walletAddress={publicAddress}
            src={avatarUrl ?? null}
            borderRadius={999}
            disableLink
            size={32}
            webappUri={webappUri}
          />
        </div>
        <div className="flex flex-1 flex-col overflow-hidden ">
          <div className="flex items-center gap-1">
            <div className="line-clamp-1 text-ellipsis  text-base-m font-semibold text-base900">
              {displayName}
            </div>
            {showVerified && <VerifiedRainbow className="h-3.5 w-3.5 flex-00auto" />}
          </div>
          <div className="text-ellipsis break-words text-base-s text-neutral500">
            {shortenHash(publicAddress, 5, 4)}
          </div>
        </div>
      </li>
    );
  },
);
MentionCell.displayName = 'MentionCell';
